import api from "./api";
import { notifyDataChanged } from "./dataEvents";

const buildBase = (basePath, kind) => `${basePath || "/admin/resources"}/${kind}`;

// Broadcast after any successful mutation so every table, list and dashboard
// refreshes immediately — no manual page refresh required.
const broadcast = (kind, basePath) => (data) => {
  notifyDataChanged(kind, basePath);
  return data;
};

export const listResources  = (kind, q = "", basePath, page = 1, pageSize = 25) => {
  const params = {};
  if (q) params.q = q;
  params.limit = pageSize;
  params.offset = (page - 1) * pageSize;
  return api.get(buildBase(basePath, kind), { params }).then((r) => r.data);
};
export const getResource    = (kind, id, basePath) => api.get(`${buildBase(basePath, kind)}/${id}`).then((r) => r.data);
export const createResource = (kind, body, basePath)   => api.post(buildBase(basePath, kind), body).then((r) => r.data).then(broadcast(kind, basePath));
export const updateResource = (kind, id, b, basePath)  => api.put(`${buildBase(basePath, kind)}/${id}`, b).then((r) => r.data).then(broadcast(kind, basePath));
export const deleteResource = (kind, id, basePath)     => api.delete(`${buildBase(basePath, kind)}/${id}`).then((r) => r.data).then(broadcast(kind, basePath));
export const toggleStatus   = (kind, id, st, basePath) => api.patch(`${buildBase(basePath, kind)}/${id}/status`, { status: st }).then((r) => r.data).then(broadcast(kind, basePath));
export const bulkCreate     = (kind, items, basePath)  => api.post(`${buildBase(basePath, kind)}/bulk`, { items }).then((r) => r.data).then(broadcast(kind, basePath));
export const bulkDelete     = (kind, ids, basePath)    => api.post(`${buildBase(basePath, kind)}/bulk-delete`, { ids }).then((r) => r.data).then(broadcast(kind, basePath));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" }); } catch { return iso; }
};

export function downloadCSV(filename, items, columns) {
  if (!items?.length) return;
  const headers = columns.map((c) => c.label);
  const keys = columns.map((c) => c.key);
  const lines = [headers.join(",")];
  for (const row of items) {
    lines.push(keys.map((k) => {
      const v = row[k];
      let s = "";
      if (v != null) {
        if (Array.isArray(v)) {
          s = v.join("; ");
        } else if (typeof v === "object") {
          s = Object.entries(v).map(([subK, subV]) => `${subK}: ${subV}`).join("; ");
        } else {
          s = String(v);
        }
        s = s.replace(/"/g, '""');
      }
      return /[",\n]/.test(s) ? `"${s}"` : s;
    }).join(","));

  }
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
